import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import {ChakraProvider, ColorModeScript} from '@chakra-ui/react';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ChakraProvider>
      <ColorModeScript initialColorMode = "light"/>
      <App />
    </ChakraProvider>
  </StrictMode>
);
